import Vue from 'vue';
import Crayon from '@senzio/crayon';
import '@senzio/crayon/lib/crayon.css';

Vue.use(Crayon);
